import axios from "axios";

// NO establecer baseURL aquí porque ya lo tenemos en API_ROUTES
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const onLoginPage = window.location.pathname === "/";

    if (
      status === 401 &&
      !url.includes("/auth/refresh-session") &&
      !url.includes("/auth/login") &&
      !url.includes("/auth/me") &&
      !onLoginPage
    ) {
      window.location.assign("/");
    }
    return Promise.reject(err);
  }
);

export default axios;
